import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, input } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
    selector: 'app-animation',
    templateUrl: './animation.component.html',
    imports: [LottieComponent],
})
export class AnimationComponent implements OnInit, OnChanges, OnDestroy {
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.autoplay()) {
            if (changes.play?.currentValue && this.animationItem) {
                this.animationItem.play();
            } else if (this.animationItem) {
                this.animationItem.stop();
            }
        }
    }
    readonly src = input('');
    readonly data = input(null);
    readonly autoplay = input(false);
    readonly loop = input(false);
    readonly play = input(false);
    options: AnimationOptions = {
        path: '',
    };
    animationItem: AnimationItem;

    ngOnInit(): void {
        const data = this.data();
        if (data) {
            this.options = {
                ...this.options,
                autoplay: this.autoplay(),
                animationData: data,
                loop: this.loop(),
            };
        } else {
            this.options = {
                ...this.options,
                path: '/assets/animations/' + this.src(),
                autoplay: this.autoplay(),
                animationData: '',
                loop: this.loop(),
            };
        }
    }

    destroyFn = (name: string) => {};
    name = '';
    animationCreated(animationItem: AnimationItem): void {
        this.animationItem = animationItem;
        this.destroyFn = animationItem.destroy;
        const _this = this;
        // redirect destroyFn to delay destroy until route animation completes.
        this.animationItem.destroy = function (name: string): void {
            _this.name = name;
        };
    }

    ngOnDestroy(): void {
        this.destroyFn(this.name);
    }
}
